/**
 * Created by mac on 7/24/17.
 */

const ScoreView = cc.Node.extend({
    ctor: function (score) {
        this._super();

        this.score = score;

        this.setAnchorPoint(0.5, 0.5);

        this.bar = new ScaledProgressBar({
            background: bundles.progress_bar.frames.bg_score,
            progress: bundles.progress_bar.frames.bar_score
        });
        this.bar.setAnchorPoint(0, 0);
        this.addChild(this.bar);

        this.stars = [];

        this.addStars();

        score.on("onChange", this.change.bind(this), this);

        if (cleverapps.config.debugMode && !cleverapps.config.editorMode) {
            this.percent = cleverapps.UI.generateImageText(0, cleverapps.styles.FONTS.MOVES_TEXT);
            this.addChild(this.percent);
        }

        this.onResize();
    },

    addStars: function () {
        for (let i = 0; i < 3; i++) {
            const star = new StarView();
            this.stars.push(star);
            this.addChild(star);
        }
    },

    onResize: function () {
        const styles = cleverapps.styles.UI.ScoreView;
        const modeStyles = styles.modes[cleverapps.resolution.mode];

        this.setRotation(modeStyles.rotation || 0);
        this.setContentSize(modeStyles.width, this.bar.height);
        this.bar.setLength(this.width);

        modeStyles.x = modeStyles.x || 0;
        this.setAlignment(modeStyles);
        this.bar.setAlignment(styles.progressBar);

        this.stars.forEach((star, index) => {
            const x = Score.COEFS[index] * this.width;
            star.setAlignment(x, this.height / 2 + styles.stars.offsetY);
            if (modeStyles.rotation) {
                star.setRotation(-modeStyles.rotation);
            }
        });

        if (this.percent) {
            this.percent.setPosition(styles.percent);
            this.percent.setScale(styles.percent.scale);
        }
    },

    change: function (data) {
        let percent = data.percent;
        const star = data.star;

        if (percent !== undefined) {
            if (percent > 100) {
                percent = 100;
            }

            this.bar.setPercentage(percent, {
                animated: true
            });

            if (cleverapps.config.debugMode && !cleverapps.config.editorMode && this.percent) {
                this.percent.setString(Math.round(percent));
            }
        }

        if (star !== undefined) {
            this.stars[star - 1].on(this.onResize.bind(this));
            cleverapps.effects.fire("match3.score.star");
        }
    }
});

const StarView = cleverapps.Spine.extend({
    ctor: function () {
        this._super(bundles.game.jsons.stars_json);

        this.setAnimation(0, "idle_off", true);

        this.setLocalZOrder(11);
    },

    on: function () {
        this.setAnimationAndIdleAfter("animation", "idle_on");
    }
});

cleverapps.styles.UI.ScoreView = {
    modes: [{
        x: { align: "center", dx: 75 },
        y: { align: "bottom", dy: 12 },
        width: 440
    }, {
        x: { align: "center", dx: 75 },
        y: { align: "bottom", dy: 12 },
        width: 440
    }, {
        x: { align: "center", dx: 80 },
        y: { align: "center", dy: 31 },
        width: 420,
        rotation: -90,
        scaleX: -1
    }],

    progressBar: {
        x: { align: "center" },
        y: { align: "center", dy: 3 }
    },

    percent: {
        x: 650,
        y: 12,
        scale: 0.7
    },

    stars: {
        offsetY: 3
    }
};